<template>
    <ymapMarker
        :markerId="markerId"
        :coords="coords"
        :balloon-template="balloonTemplate"
        :options="{
            preset: 'islands#redPersonCircleIcon',
            hideIconOnBalloonOpen: false,
        }"
    />
</template>

<script>
import { ymapMarker } from 'vue-yandex-maps';

export default {
    props: ['markerId', 'coords', 'info'],
    name: 'clientMarker',
    components: {
        ymapMarker,
    },
    computed: {
        balloonTemplate() {
            return `<div>${
                this.info.name
            }</div><div>+7 ${this.info.phone.replace(
                /^(\d{3})(\d{3})(\d{2}).*/,
                '$1-$2-$3'
            )}</div>`;
        },
    },
};
</script>

<style scoped></style>
